import { allFromSnapshot, firstFromSnapshot, oneFromSnapshot, } from "@buildwithflux/firestore-compatibility-layer";
import { AutoPlacementJob } from "@buildwithflux/models";
import { silentLogger } from "@buildwithflux/shared";
import { StorageSubscriptionManager } from "../subscriptions";
export class FirestoreAutoPlacementJobRepository {
    db;
    logger;
    subscriptionMgr = new StorageSubscriptionManager();
    firestoreSubscriptions = new Map();
    constructor(db, logger = silentLogger) {
        this.db = db;
        this.logger = logger;
    }
    /* @inheritDoc */
    subscribe(userHandle, jobUid, onChange) {
        const jobRef = this.db.userJobsCollection(userHandle).doc(jobUid);
        // Here's the other half - we're erasing the type inside the subscription and then reviving it when we fire the callback.
        const unsubscribe = this.subscriptionMgr.addSubscription(jobUid, onChange, () => {
            const existingSubCount = this.subscriptionMgr.listenerCount(jobUid);
            if (existingSubCount === 0) {
                const firestoreUnsub = this.firestoreSubscriptions.get(jobUid);
                if (firestoreUnsub) {
                    firestoreUnsub();
                    this.firestoreSubscriptions.delete(jobUid);
                }
            }
        });
        const existing = this.firestoreSubscriptions.get(jobUid);
        if (!existing) {
            const firestoreUnsub = jobRef.onSnapshot((snapshot) => {
                const data = snapshot.data();
                if (!data) {
                    this.logger.warn(`Job ${jobUid} does not exist in Firestore!`);
                    return;
                }
                this.notifyJobChangeListeners(jobUid, { type: "updated", data: AutoPlacementJob.parse(data) });
            });
            this.firestoreSubscriptions.set(jobUid, firestoreUnsub);
        }
        return unsubscribe;
    }
    /* @inheritDoc */
    async save(userHandle, job) {
        this.db.userJobsCollection(userHandle).doc(job.jobUid).set(job, { merge: true }).then();
    }
    /* @inheritDoc */
    async get(userHandle, jobUid) {
        const raw = oneFromSnapshot(await this.db.userJobsCollection(userHandle).doc(jobUid).get(), () => undefined);
        if (!raw)
            return undefined;
        return AutoPlacementJob.parse(raw);
    }
    /* @inheritDoc */
    async getActiveJobForProject(userHandle, userUid, projectUid) {
        const job = firstFromSnapshot(await this.db
            .userJobsCollection(userHandle)
            .where("submittedByUserUid", "==", userUid)
            .where("type", "==", "autoPlacement")
            .where("projectUid", "==", projectUid)
            .where("active", "==", true)
            .orderBy("createAt", "desc")
            .get(), () => undefined);
        if (job?.type !== "autoPlacement")
            return undefined;
        return job;
    }
    /* @inheritDoc */
    async getActiveJobsForProject(userHandle, userUid, projectUid) {
        const jobs = allFromSnapshot(await this.db
            .userJobsCollection(userHandle)
            .where("submittedByUserUid", "==", userUid)
            .where("type", "==", "autoPlacement")
            .where("projectUid", "==", projectUid)
            .where("active", "==", true)
            .orderBy("createAt", "desc")
            .get());
        return jobs
            .filter((j) => j?.type === "autoPlacement")
            .map((j) => AutoPlacementJob.parse(j));
    }
    notifyJobChangeListeners(jobUid, change) {
        this.subscriptionMgr.notify(jobUid, change);
    }
}
//# sourceMappingURL=FirestoreAutoPlacementJobRepository.js.map